import React from "react";
import { View, XStack } from "tamagui";
import { brandShadowSm } from "../../../../../tamagui.config";
import { useGetGroupIcon } from "../../../../features/Events/hooks/useGetEventGroupIcons";
import { Pill } from "../../../../components/design-system/Pill";
import { getMiles, getFeet } from "../../../../features/Routes/utils";
import { Event } from "../../../../types/event";

const getVisibilityText = (visibility: Event["visibility"]) => {
  switch (visibility) {
    case "Private":
      return "Private";
    case "Public":
      return "Public";
    default:
      return "Public";
  }
};

type GroupIconProps = {
  group: "A" | "B" | "C" | "D" | "Party";
};

const GroupIcon = ({ group }: GroupIconProps) => {
  const Icon = useGetGroupIcon({ group });

  if (!Icon) return null;

  return (
    <View {...brandShadowSm} borderWidth={1} borderRadius={999}>
      <Icon width={32} height={32} />
    </View>
  );
};

type EventDetailRoutePillsProps = {
  route: Event["route"];
  groups: Event["groups"];
  terrain: Event["terrain"];
  visibility: Event["visibility"];
  isClubRide?: boolean;
};

export const EventDetailRoutePills = ({
  route,
  groups,
  terrain,
  visibility,
  isClubRide,
}: EventDetailRoutePillsProps) => {
  if (!route && !isClubRide) return null;

  return (
    <XStack
      justifyContent="flex-start"
      alignItems="center"
      gap="$2"
      flexWrap="wrap"
      px="$4"
      mt="$4"
    >
      {groups?.map((g) => (
        <GroupIcon key={g} group={g} />
      ))}

      {route ? (
        <>
          <Pill
            bg="$brandYellow"
            borderColor="black"
            text={`${getMiles(route.distance ?? 0) ?? ""} mi`}
          />
          <Pill
            bg="$brandYellow"
            borderColor="black"
            text={`${getFeet(route.elevation ?? 0)} ft`}
          />
        </>
      ) : (
        <Pill bg="$brandYellow" borderColor="black" text="Route coming soon" />
      )}
      {terrain ? (
        <Pill bg="$brandYellow" borderColor="black" text={terrain} />
      ) : null}
      <Pill
        bg="$brandYellow"
        borderColor="black"
        text={getVisibilityText(visibility)}
      />
    </XStack>
  );
};
